import { Save, X } from "lucide-react";
import React, { useEffect, useState } from "react";
import Spacing from "../Spacing";
import { can_visit } from "../../helpers";

export default function EditUserRoleModal({
  onClose = () => {},
  userData = {},
  handleUpdatedUserRole = () => {},
  userRoles = []
}) {
  const [invitedUserData, setInvitedUserData] = useState({
    roles: [],
  });

  const handleChangeRoles = (value) => {
    setInvitedUserData({
      ...invitedUserData,
      roles: invitedUserData.roles.includes(value)
        ? invitedUserData.roles.filter((role) => role !== value)
        : [...invitedUserData.roles, value],
    });
  };

  useEffect(() => {
    setInvitedUserData(userData);
  }, [userData]);

  return (
    <>
      <div className="docpro_modal_wrap">
        <div className="docpro_modal_overlay"></div>
        <div className="docpro_modal">
          <button
            className="docpro_close_btn"
            onClick={onClose}
          >
            <X />
          </button>
          <h2 className="docpro_fs_24">Edit user Roles</h2>

          <div className="docpro_grid docpro_grid_gap_20_16 docpro_grid_col_1">
            <div className="docpro_grid_item">
              <label className="docpro_fw_500 docpro_primary_color">Check Roles</label>
              <ul className="docpro_checkmark_list">
                {(can_visit("administrator") ? userRoles : userRoles?.filter(
                    (role) => !["Trial", "System", "Enterprise"].includes(role)
                  ))?.map((item, index) => (
                    <li key={index}>
                      <div className="docpro_checkbox" style={{ top: "3px" }}>
                        <input
                          type="checkbox"
                          checked={invitedUserData.roles.includes(item)}
                          onChange={() => handleChangeRoles(item)}
                        />
                        <label>
                          <span style={{ marginLeft: "8px" }}>{item}</span>
                        </label>
                      </div>
                    </li>
                  )
                )}
              </ul>
            </div>
          </div>
          <Spacing lg="32" sm="32" />
          <div className="docpro_modal_btns">
            <button
              className="docpro_bordered_btn docpro_fw_600 docpro_filed_btn size_lg"
              onClick={() =>
                handleUpdatedUserRole(
                  {
                    ...invitedUserData,
                    resend: true,
                  },
                  () => {
                    onClose();
                  }
                )
              }
              style={{ minWidth: "170px" }}
            >
              <Save width={20} height={20} />
              Update
            </button>
          </div>
        </div>
      </div>
    </>
  );
}
